<template>
  <tr class="payment-row">
    <td class="text-center" >{{ payment.attributes.payment_reference }}</td>
    <td class="text-center" >{{ payment.attributes.user_rut }}</td>
    <td class="text-center" >{{ user_name }}</td>
    <td class="text-center" >
      <a class="a" :class="this.payment.attributes.state != 'COMPLETED' ? 'arrears-text' : ''">{{
        getStateText(payment.attributes.state) }}</a>
    </td>
    <td class="text-center" >{{ formatDate(payment.attributes.limit_date) }}</td>
    <td class="text-center" >{{ formatDate(payment.attributes.payment_agreement_date) }}</td>
    <td class="text-center" >{{ days_over_due(payment) }}</td>
    <td class="text-center" >{{ formatAmount(payment.attributes.amount) }}</td>
    <td class="text-center" >
      {{ payment.attributes.locations.map(location => location.location_name).join(', ') }}
    </td>
    <td class="text-center" >
      {{ payment.attributes.locations.map(location => location.service_name).join(', ') }}
    </td>
    <td class="text-center" >
      <div class="configure_property__payment--send_btn">
        <v-btn style="width: 50%; background-color: #1476FB;" class="v-btn theme--light info" round
          @click="showConfirmModal(payment)"
          v-if="payment.attributes.state === 'PENDING' && payment.attributes.support_files.length === 0">
          {{ payment.attributes.notified ? 'Reenviar' : 'Enviar' }}
        </v-btn>

        <v-btn style="width: 50%;" class="v-btn theme--light success" round
          @click="showSupportFileModal(payment, payment.attributes.support_files)" v-else>
          Ver
        </v-btn>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  computed: {
    user_name() {
      const user = this.payment.attributes.user;
      if (user && user.name && user.last_name) {
        return user.name + ' ' + user.last_name;
      }
      return '';
    }
  },

  props: {
    payment: {
      type: Object,
      required: true,
    },
  },
  methods: {

    formatDate(date) {
      // Verifica si la fecha es null o undefined
      if (date === null || date === undefined) {
        return ''; // o puedes devolver null, dependiendo de lo que necesites
      }

      // Formatear solo el mes como texto
      return new Date(date).toLocaleDateString('es-CO', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },

    formatAmount(amount) {
      // Formatear el monto con símbolo de pesos
      return `$${amount.toLocaleString()}`; // Suponiendo que amount es un número
    },
    getStateText(state) {
      // Cambiar el texto del estado
      switch (state) {
        case 'PENDING':
          return 'Pendiente';
        case 'COMPLETED':
          return 'Completado';
        default:
          return state; // En caso de que haya un estado desconocido
      }
    },
    showConfirmModal(payment) {

      // Implementar la lógica para mostrar el modal de confirmación
      this.$emit('showConfirmModal', payment);
    },
    showSupportFileModal(payment, supportFiles) {
      // Implementar la lógica para mostrar el modal de archivos de soporte
      console.log(payment, supportFiles)
      this.$emit('showSupportFileModal', payment, supportFiles);
    },
    days_over_due(value) {
      if (value.attributes.state === 'COMPLETED') {
        return 0;
      }

      const limitDate = new Date(value.attributes.limit_date);
      const currentDate = new Date();
      if (limitDate < currentDate) {
        let lastSupport = value.attributes.support_files ? value.attributes.support_files[value.attributes.support_files.length - 1] : null;
        if (lastSupport && lastSupport.state === 'REJECTED') {
          return Math.floor((currentDate - limitDate) / (1000 * 60 * 60 * 24));
        }
        return Math.floor((currentDate - limitDate) / (1000 * 60 * 60 * 24));
      }

      return 0;
    }


  },
};
</script>

<style scoped>
.payment-row {
  transition: background-color 0.3s;
  cursor: pointer;
}

.payment-row:hover {
  background-color: #f5f5f5;
  /* Color de fondo al pasar el ratón */
}

.text-center {
  text-align: center;
  align-items: center;
  padding-left: 12px;
}

.configure_property__payment--send_btn {

  justify-content: center;
  /* Centrar los botones */

}

.v-btn {

  margin: 0 5px;
  /* Margen entre botones */
}

.arrears-text {

  color: rgb(250, 0, 0);
  /* Color de fondo para celdas en mora */
}
</style>



// WEBPACK FOOTER //
// src/components/views/users/payment_status/PaymentsTableRow.vue